module.exports = __webpack_public_path__ + "uy.svg?011aeeb94af99b085cdc4c156a7e8174";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/uy.svg
// module id = 1160
// module chunks = 27